import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { isUndefined } from 'util';

import { DeptTreeNode } from './dept-tree-node';
import { DeptTreeService } from './dept-tree.service';

@Component({
  selector: 'nec-dept-tree',
  templateUrl: './dept-tree.component.html',
  styleUrls: ['./dept-tree.component.scss']
})
export class NecDeptTreeComponent implements OnInit, OnChanges {

  @Input() depts?: DeptTreeNode[];

  @Input() selectedNode: any;

  @Input() selectionMode?: string; // 'single' or 'checkbox'ï¼é»è®¤'single'

  @Input() showAllSelectBox = false; // æ¯å¦æ¾ç¤ºæéæé®

  @Input() showOverflow = false; // æ¯å¦ææ»å¨ææ

  @Input() showShadow = false; // æ¯å¦æ¾ç¤ºshadowæ ·å¼

  @Input() showSearchBox = false; // æ¯å¦æ¾ç¤ºæç´¢æ¡

  @Input() showButtonBox = false; // æ¯å¦æ¾ç¤ºç¡®è®¤æé®  åªå¨selectionMode='checkbox'ææ

  @Input() singleOnly = false; //  selectionMode = 'checkbox'ï¼ ä¸ºtrueæ¶è¡¨ç¤ºç§å®¤æ éæ©ä¸ä¸çº§ä¸èå¨ï¼ é»è®¤false'

  @Input() onlyShowDept = false; // æ¯å¦åªæ¾ç¤ºç§å®¤æ°ï¼true:åªæ¾ç¤ºç§å®¤ï¼ false: æ¾ç¤ºç§å®¤åå°ç»

  @Output() selectedNodeChange = new EventEmitter();

  @Output() selectAllChange = new EventEmitter();

  @Output() confirmChange = new EventEmitter();

  searchState = false;

  selectedNodeLocals: DeptTreeNode[] = [];

  showDeptNodes: DeptTreeNode[] = []; // ç­éåçæ°æ®æº

  isSelectAll = false; // æ¯å¦å¨é

  deptMap = new Map();

  constructor(private deptTreeService: DeptTreeService) {
    if (isUndefined(this.selectionMode)) {
      this.selectionMode = 'single';
    }
    if (isUndefined(this.depts)) {
      this.depts = deptTreeService.getDeptTree(this.onlyShowDept);
    }
    if (this.selectionMode == 'checkbox' && !this.selectedNode) {
      this.selectedNode = [];
    }
    if (this.selectionMode == 'checkbox' && !(this.selectedNode instanceof Array)) {
      this.selectedNode = [this.selectedNode];
    }
    this.showDeptNodes = this.depts;
  }

  ngOnInit() {
    this.searchState = false;
    this.init();
    this.selectedNodeChange.emit(this.selectedNode);
  }

  ngOnChanges(changes: SimpleChanges) {

    let nodes = changes.depts ? changes.depts.currentValue : [];
    if (nodes.length > 0) {
      this.showDeptNodes = this.depts;
    }

    let node = changes.selectedNode ? changes.selectedNode.currentValue : undefined;
    if (node) {
      this.init();
    }
  }

  nodeSelect(event, selectedNode: DeptTreeNode) {
    if (this.selectionMode === 'checkbox' && this.singleOnly) {
      this.selectedNodeLocals = this.selectedNodeLocals.filter(nodeLocal => nodeLocal.deptId !== selectedNode.deptId);
      this.selectedNodeLocals.push(selectedNode);
      this.selectedNode = this.deptTreeService.getMultiSelectedNodes(this.showDeptNodes, this.selectedNodeLocals);
      this.deptTreeService.expandNode(this.showDeptNodes, selectedNode, true);
    }
    let selectAll = this.selectionMode === 'checkbox' && this.deptTreeService.isAllSelected(this.selectedNode, this.showDeptNodes);
    if (this.showAllSelectBox) {
      this.isSelectAll = selectAll;
    }
    this.selectAllChange.emit(selectAll);
    this.selectedNodeChange.emit(this.selectedNode);
  }

  nodeUnselect(event, selectedNode: DeptTreeNode) {
    if (this.selectionMode === 'checkbox' && this.singleOnly) {
      this.selectedNodeLocals = this.selectedNodeLocals.filter(nodeLocal => nodeLocal.deptId !== selectedNode.deptId);
      this.selectedNode = this.deptTreeService.getMultiSelectedNodes(this.showDeptNodes, this.selectedNodeLocals);
      this.deptTreeService.expandNode(this.showDeptNodes, selectedNode, true);
    }
    this.isSelectAll = false;
    this.selectAllChange.emit(false);
    this.selectedNodeChange.emit(this.selectedNode);
  }

  search(searchText: string) {
    searchText = this.deptTreeService.filterSpace(searchText);
    setTimeout(() => {
      if (searchText === '') {
        this.searchState = false;
        this.showDeptNodes = this.depts;
      } else {
        this.searchState = true;
        this.showDeptNodes = this.deptTreeService.searchDeptsByText(searchText, this.onlyShowDept);
        this.getNodeMap(this.depts);
        this.showDeptNodes.forEach(node => {
          let dept = this.deptMap.get(node.deptId);
          if (dept && dept.selectable === false) {
            node.selectable = false;
          }
        })
      }
      this.init();
      if (this.showAllSelectBox) {
        this.isSelectAll = this.selectionMode === 'checkbox'
          && this.deptTreeService.isAllSelected(this.selectedNode, this.showDeptNodes);
      }
    }, 100);
  }

  confirm() {
    this.confirmChange.emit(this.selectedNode);
  }

  /**
   * éæ©ææç§å®¤
   */
  selectAll() {
    this.isSelectAll = !this.isSelectAll;
    if (this.isSelectAll) {
      this.deptTreeService.selectAllNode(this.showDeptNodes, this.selectedNode);
      if (this.selectionMode === 'checkbox' && this.singleOnly) {
        this.selectedNodeLocals = this.selectedNode;
      }
      this.selectAllChange.emit(true);
      this.selectedNodeChange.emit(this.selectedNode);
    } else {
      this.deptTreeService.cancelSelectAllNode(this.showDeptNodes, this.selectedNode);
      if (this.selectionMode === 'checkbox' && this.singleOnly) {
        this.selectedNodeLocals = this.selectedNode;
      }
      this.selectAllChange.emit(false);
      this.selectedNodeChange.emit(this.selectedNode);
    }
  }

  private init() {
    if (this.selectionMode === 'single') {
      setTimeout(() => {
        this.selectedNode = this.deptTreeService.getSingleSelectedNode(this.showDeptNodes, this.selectedNode);
      }, 200);
    } else {
      setTimeout(() => {
        this.selectedNode = this.deptTreeService.getMultiSelectedNodes(this.showDeptNodes, this.selectedNode);
        this.selectedNodeLocals = this.selectedNode;
        this.selectedNode.forEach(node => {
          this.deptTreeService.expandNode(this.showDeptNodes, node, true);
        });
        this.isSelectAll = this.selectionMode === 'checkbox'
          && this.deptTreeService.isAllSelected(this.selectedNode, this.showDeptNodes);
      }, 200);
    }
  }

  private getNodeMap(nodes: DeptTreeNode[]) {
    nodes.forEach(node => {
      this.deptMap.set(node.deptId, node);
      if (node.children && node.children.length > 0) {
        this.getNodeMap(node.children);
      }
    })
  }
}
